import { Routes } from '@angular/router'
import { adminAuthGuard } from './core/auth/admin-auth.guard'
import { adminGuestGuard } from './core/auth/admin-guest.guard'
import { adminRoleGuard } from './core/auth/admin-role.guard'
import { blogUnsavedChangesGuard } from './pages/blog-editor/blog-editor.guard'
import { placeUnsavedChangesGuard } from './pages/place-editor/place-editor.guard'
import { placesAdminFeatureGuard } from './core/config/places-admin-feature.guard'

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [adminGuestGuard],
    loadComponent: () =>
      import('./pages/login/login-page.component').then(
        (m) => m.LoginPageComponent
      ),
  },
  {
    path: '',
    canActivate: [adminAuthGuard],
    loadComponent: () =>
      import('./layout/admin-shell.component').then(
        (m) => m.AdminShellComponent
      ),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-page.component').then(
            (m) => m.DashboardPageComponent
          ),
      },
      {
        path: 'map-data',
        loadComponent: () =>
          import('./pages/map-data/map-data-page.component').then(
            (m) => m.MapDataPageComponent
          ),
      },
      {
        path: 'points',
        loadComponent: () =>
          import('./pages/map-points/map-points-page.component').then(
            (m) => m.MapPointsPageComponent
          ),
      },
      {
        path: 'conflicts',
        loadComponent: () =>
          import('./pages/map-conflicts/map-conflicts-page.component').then(
            (m) => m.MapConflictsPageComponent
          ),
      },
      {
        path: 'imports',
        canActivate: [adminRoleGuard],
        loadComponent: () =>
          import('./pages/map-imports/map-imports-page.component').then(
            (m) => m.MapImportsPageComponent
          ),
      },
      {
        path: 'route-previews',
        loadComponent: () =>
          import('./pages/route-previews/route-previews-page.component').then(
            (m) => m.RoutePreviewsPageComponent
          ),
      },
      {
        path: 'routes',
        loadComponent: () =>
          import('./pages/routes-moderation/routes-moderation-page.component').then(
            (m) => m.RoutesModerationPageComponent
          ),
      },
      {
        path: 'routes/new',
        loadComponent: () =>
          import('./pages/route-create/route-create-page.component').then(
            (m) => m.RouteCreatePageComponent
          ),
      },
      {
        path: 'routes/tags',
        loadComponent: () =>
          import('./pages/route-tags/route-tags-page.component').then(
            (m) => m.RouteTagsPageComponent
          ),
      },
      {
        path: 'regions',
        loadComponent: () =>
          import('./pages/regions/regions-page.component').then(
            (m) => m.RegionsPageComponent
          ),
      },
      {
        path: 'trail-media',
        loadComponent: () =>
          import('./pages/trail-media/trail-media-page.component').then(
            (m) => m.TrailMediaPageComponent
          ),
      },
      {
        path: 'routes/:id/edit',
        loadComponent: () =>
          import('./pages/route-editor/route-editor-page.component').then(
            (m) => m.RouteEditorPageComponent
          ),
      },
      {
        path: 'places',
        canMatch: [placesAdminFeatureGuard],
        loadComponent: () =>
          import('./pages/places/places-page.component').then(
            (m) => m.PlacesPageComponent
          ),
      },
      {
        path: 'places/new',
        canMatch: [placesAdminFeatureGuard],
        loadComponent: () =>
          import('./pages/place-create/place-create-page.component').then(
            (m) => m.PlaceCreatePageComponent
          ),
      },
      {
        path: 'places/:id/edit',
        canMatch: [placesAdminFeatureGuard],
        canDeactivate: [placeUnsavedChangesGuard],
        loadComponent: () =>
          import('./pages/place-editor/place-editor-page.component').then(
            (m) => m.PlaceEditorPageComponent
          ),
      },
      {
        path: 'media',
        loadComponent: () =>
          import('./pages/media-library/media-library-page.component').then(
            (m) => m.MediaLibraryPageComponent
          ),
      },
      {
        path: 'newsletter',
        canActivate: [adminRoleGuard],
        loadComponent: () =>
          import('./pages/newsletter/newsletter-page.component').then(
            (m) => m.NewsletterPageComponent
          ),
      },
      {
        path: 'support-messages',
        loadComponent: () =>
          import('./pages/support-messages/support-messages-page.component').then(
            (m) => m.SupportMessagesPageComponent
          ),
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('./pages/blog/blog-posts-page.component').then(
            (m) => m.BlogPostsPageComponent
          ),
      },
      {
        path: 'blog/new',
        canDeactivate: [blogUnsavedChangesGuard],
        loadComponent: () =>
          import('./pages/blog-editor/blog-editor-page.component').then(
            (m) => m.BlogEditorPageComponent
          ),
      },
      {
        path: 'blog/editorial-proposals',
        loadComponent: () =>
          import('./pages/blog-editorial-proposals/blog-editorial-proposals-page.component').then(
            (m) => m.BlogEditorialProposalsPageComponent
          ),
      },
      {
        path: 'blog/taxonomy',
        loadComponent: () =>
          import('./pages/blog-taxonomy/blog-taxonomy-page.component').then(
            (m) => m.BlogTaxonomyPageComponent
          ),
      },
      {
        path: 'blog/:id/edit',
        canDeactivate: [blogUnsavedChangesGuard],
        loadComponent: () =>
          import('./pages/blog-editor/blog-editor-page.component').then(
            (m) => m.BlogEditorPageComponent
          ),
      },
      {
        path: 'admins',
        canActivate: [adminRoleGuard],
        loadComponent: () =>
          import('./pages/admins/admins-page.component').then(
            (m) => m.AdminsPageComponent
          ),
      },
      {
        path: 'app-users',
        canActivate: [adminRoleGuard],
        loadComponent: () =>
          import('./pages/app-users/app-users-page.component').then(
            (m) => m.AppUsersPageComponent
          ),
      },
      {
        path: 'push-notifications',
        loadComponent: () =>
          import('./pages/push-notifications/push-notifications-page.component').then(
            (m) => m.PushNotificationsPageComponent
          ),
      },
      {
        path: 'routes-moderation',
        loadComponent: () =>
          import('./pages/route-moderation-redirect/route-moderation-redirect-page.component').then(
            (m) => m.RouteModerationRedirectPageComponent
          ),
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./pages/security/security-page.component').then(
            (m) => m.SecurityPageComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
]
